import type { WorkspaceMemberOption } from './audit-filters';
import type { AuditEvent } from './types';

export interface AuditPrincipalDisplay {
  userId: string | null;
  label: string;
  title?: string;
  avatarName: string;
  avatarUrl: string | null;
}

function clean(value: string | null | undefined): string {
  return typeof value === 'string' ? value.trim() : '';
}

function localPart(email: string): string {
  return email.split('@')[0] || email;
}

export function resolveAuditPrincipalDisplay(
  event: AuditEvent,
  members: readonly WorkspaceMemberOption[],
  systemLabel = 'System',
  unknownUserLabel = 'Unknown user'
): AuditPrincipalDisplay {
  const eventEmail = clean(event.userEmail);
  const eventEmailKey = eventEmail.toLowerCase();
  const member = event.userId
    ? members.find(candidate => candidate.id === event.userId)
    : eventEmailKey
      ? members.find(
          candidate => clean(candidate.email).toLowerCase() === eventEmailKey
        )
      : undefined;
  const memberName = clean(member?.name);
  const memberEmail = clean(member?.email);
  const eventName = clean(event.userName);
  const email = memberEmail || eventEmail;

  const label =
    memberName ||
    eventName ||
    email ||
    (event.userId ? unknownUserLabel.trim() || 'Unknown user' : '') ||
    systemLabel.trim() ||
    'System';
  const normalizedLabel = label.trim() || systemLabel.trim() || 'System';
  const title = email && normalizedLabel !== email ? email : undefined;

  return {
    userId: member?.id ?? event.userId ?? null,
    label: normalizedLabel,
    title,
    avatarName:
      memberName || eventName || (email ? localPart(email) : normalizedLabel),
    avatarUrl: member?.avatarUrl ?? event.userAvatarUrl ?? null,
  };
}
